module.exports = __webpack_public_path__ + "static/img/lmsj_gif.b2284e5.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity20240117/lmsj_gif.gif
// module id = fIxd
// module chunks = 0